import Cookies from 'js-cookie'

import { SDKCookies } from '../generated/types'
import { SDKCookieJSON } from 'config/types/codegen'
import {
  CookieGetResult,
  CookieSetResult,
  BrowserCookieAttributes,
} from '../types/cookies'

import SDKCookieRecord from '../generated/SDKCookies.json'

import { CONSENT_COOKIE } from '../consent/config'
import { CONSENT_CATEGORY } from '../../config/types/consent'
import { notInBrowser } from '../environment'

const cookiePolicies = SDKCookieRecord as SDKCookieJSON

class BrowserCookies {
  getString(key: SDKCookies): CookieGetResult<string> {
    if (notInBrowser()) {
      return [false, undefined]
    }

    if (!this.isCookieConsented(key)) {
      return [false, undefined]
    }

    const cookie = Cookies.get(key)
    if (!cookie) {
      return [true, undefined]
    }

    return [true, cookie]
  }

  getJSON<T>(key: SDKCookies): CookieGetResult<T> {
    const [consent, cookie] = this.getString(key)
    if (!cookie) {
      return [consent, undefined]
    }

    return [consent, JSON.parse(cookie)]
  }

  setString(
    key: SDKCookies,
    value: string,
    attributes?: BrowserCookieAttributes,
  ): CookieSetResult {
    if (notInBrowser()) {
      return [false]
    }

    if (!this.isCookieConsented(key)) {
      return [false]
    }

    Cookies.set(key, value, attributes)

    return [true]
  }

  setJSON(
    key: SDKCookies,
    json: unknown,
    attributes?: BrowserCookieAttributes,
  ): CookieSetResult {
    const [consent] = this.setString(key, JSON.stringify(json), attributes)

    return [consent]
  }

  private isCookieConsented(key: SDKCookies) {
    // Strictly necessary cookies are allowed, even if the user has not consented yet
    if (cookiePolicies[key]?.category === CONSENT_CATEGORY.STRICTLY_NECESSARY) {
      return true
    }

    const consentCookie = Cookies.get(CONSENT_COOKIE)
    if (!consentCookie) {
      return false
    }

    const consents = JSON.parse(consentCookie).categories as string[]
    return consents.includes(cookiePolicies[key]?.category)
  }
}

export const browserCookies = new BrowserCookies()
